module.exports = __webpack_public_path__ + "img/SI.799ba3e3.svg";